import { Activity, TableName } from 'v2/models';
import { LinkedEntityType } from '../enums';

const TABLE_NAME_TO_LINKED_ENTITY_TYPE: Record<
  TableName,
  LinkedEntityType | null
> = {
  [TableName.DataVendor]: LinkedEntityType.DATA_VENDOR,
  [TableName.Contact]: LinkedEntityType.CONTACT,
  [TableName.DataProduct]: LinkedEntityType.DATASET,
  [TableName.Searches]: null,
};

export function getLinkedEntityType(
  activity: Activity
): LinkedEntityType | null {
  const firstRelationship = activity.relationships
    .filter((relationship) => relationship.table_name !== TableName.Searches)
    .at(-1);

  if (!firstRelationship) return null;

  return TABLE_NAME_TO_LINKED_ENTITY_TYPE[
    firstRelationship.table_name as TableName
  ];
}
